interface RoleSelectProps {
  selectedRole: 'patient' | 'caregiver' | '';
  onSelect: (role: 'patient' | 'caregiver') => void;
}

export default function RoleSelect({ selectedRole, onSelect }: RoleSelectProps) {
  return (
    <div className="space-y-4">
      <button
        onClick={() => onSelect('patient')}
        className={`w-full p-5 rounded-2xl border-2 text-left cursor-pointer transition-all ${
          selectedRole === 'patient'
            ? 'border-[#2E7D6B] bg-[#f0f9f6]'
            : 'border-gray-100 hover:border-gray-300 bg-gray-50'
        }`}
      >
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-xl flex items-center justify-center shrink-0 bg-[#E8F5E9]">
            <i className="ri-hospital-line text-2xl text-[#2E7D6B]" />
          </div>
          <div className="flex-1">
            <h3 className="font-bold text-gray-900 text-base">환자 / 보호자</h3>
            <p className="text-xs text-gray-500 mt-0.5">간병인을 찾아 매칭 신청할게요</p>
          </div>
          {selectedRole === 'patient' && (
            <i className="ri-checkbox-circle-line text-[#2E7D6B] text-xl" />
          )}
        </div>
      </button>

      <button
        onClick={() => onSelect('caregiver')}
        className={`w-full p-5 rounded-2xl border-2 text-left cursor-pointer transition-all ${
          selectedRole === 'caregiver'
            ? 'border-[#1976D2] bg-blue-50'
            : 'border-gray-100 hover:border-gray-300 bg-gray-50'
        }`}
      >
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-xl flex items-center justify-center shrink-0 bg-[#E3F2FD]">
            <i className="ri-nurse-line text-2xl text-[#1976D2]" />
          </div>
          <div className="flex-1">
            <h3 className="font-bold text-gray-900 text-base">간병인</h3>
            <p className="text-xs text-gray-500 mt-0.5">프로필 등록하고 일자리를 찾을게요</p>
          </div>
          {selectedRole === 'caregiver' && (
            <i className="ri-checkbox-circle-line text-[#1976D2] text-xl" />
          )}
        </div>
      </button>
    </div>
  );
}